<template>
    <div class="common_container">
        <el-form :model="ruleForm" :rules='rules' ref="ruleForm" v-loading='loading'  label-width="120px">

            <!-- 名称 付款周期 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="名称" prop='title'>
                        <el-input v-model="ruleForm.title" class="common-input"/>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="付款周期" prop='paymentCycle'>
                        <el-input type='number' v-model="ruleForm.paymentCycle" class="common-input" min="0"/> 月份
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 开始有效时间 费用 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="有效开始时间" prop='warrantyStartTime'>
                        <el-date-picker
                        style="width:175px;"
                        value-format='yyyy-MM-dd HH:mm:ss'
                        v-model="ruleForm.warrantyStartTime"
                        type="date"
                        placeholder="选择日期" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="费用" prop='cost'>
                        <el-input v-model="ruleForm.cost" class="common-input"  type='number' min='0'/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 结束有效时间 货币单位 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="结束有效时间" prop='warrantyEndTime'>
                        <el-date-picker
                        style="width:175px"
                        value-format='yyyy-MM-dd HH:mm:ss'
                        v-model="ruleForm.warrantyEndTime"
                        type="date" placeholder="选择日期" />
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="货币单位">
                        <el-select v-model="ruleForm.costType" class="common-input">
                            <el-option
                            v-for='item of costType'
                            :key='item.id'
                            :label="item.cname"
                            :value="item.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 客户 合同状态 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="客户" prop='customer'>
                        <el-select v-model="ruleForm.customer" placeholder="请选择" class="common-input">
                            <el-option
                            v-for="item in companyData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="合同状态">
                        <el-select v-model="ruleForm.status" class="common-input">
                            <el-option
                            v-for='item of contractStatus'
                            :key='item.id'
                            :label="item.cname"
                            :value="item.id"/>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 供应商 合同类型 -->
            <el-row>
                <el-col :span="12" >
                    <el-form-item label="供应商" prop='supplier'>
                        <el-select v-model="ruleForm.supplier" placeholder="请选择" class="common-input">
                            <el-option
                            v-for="item in companyData"
                            :key="item.id"
                            :label="item.name"
                            :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>

                <el-col :span="12">
                    <el-form-item label="合同类型">
                        <el-select v-model="ruleForm.contactType" class="common-input">
                            <el-option
                            v-for='item of contactType'
                            :key='item.id'
                            :label="item.cname"
                            :value="item.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <!--描述  -->
            <el-row>
                <el-col :span="24" >
                    <el-form-item label="描述">
                        <el-input type='textarea' v-model="ruleForm.description" class="form-input"/>
                    </el-form-item>
                </el-col>
            </el-row>

            <!-- 服务范围 -->
            <el-row>
                <el-col :span="24" >
                    <el-form-item label="服务范围">
                        <el-select v-model="ruleForm.toDepartment" multiple collapse-tags class="common-input">
                            <el-option
                            v-for='item of parentNumber'
                            :key='item.id'
                            :label="item.name"
                            :value="item.id" />
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <div style='clear:both'></div>

            <!-- 服务项 -->
            <el-form-item label="服务项">

                <el-button type='primary' @click="ShowBounced('选择服务项')">新增</el-button>

                <el-table v-if='ruleForm.toService.length' :data="ruleForm.toService" style="width: 100%" max-height="250">
                    <el-table-column prop="title" label="新增" />
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                            @click.native.prevent="deleteRow(scope.$index, ruleForm.toService)"
                            type="text">
                            移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-form-item>

            <!-- 联系人 -->
            <el-form-item label="联系人">

                <el-button type='primary' @click="ShowBounced('选择联系人')">新增</el-button>

                <el-table v-if='ruleForm.toUser.length' :data="ruleForm.toUser" style="width: 100%" max-height="250">
                    <el-table-column label="用户名" prop="internalUserid"></el-table-column>
                    <el-table-column label="真实姓名" prop="name"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                            @click.native.prevent="deleteRow(scope.$index, ruleForm.toUser)"
                            type="text">
                            移除
                            </el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-form-item>

            <!-- 文件 -->
            <el-form-item label="文件">

                <el-button type='primary' @click="ShowBounced('在线文档')">新增</el-button>

                <el-table v-if='ruleForm.toDocument.length' :data="ruleForm.toDocument" style="width: 100%" max-height="250">
                    <el-table-column label="文件名" prop="title"></el-table-column>
                    <el-table-column label="描述" prop="description"></el-table-column>
                    <el-table-column label="创建人" prop="createUser"></el-table-column>
                    <el-table-column label="上传时间" prop="createTime"></el-table-column>
                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <el-button
                            @click.native.prevent="deleteRow(scope.$index, ruleForm.toDocument)"
                            type="text">移除</el-button>
                        </template>
                    </el-table-column>
                </el-table>

            </el-form-item>

            <el-form-item>
                <el-button
                type="primary" size="small"
                @click="submitForm('ruleForm')" :disabled="isSubmit">{{ type == 'edit' ? '修改' : '创建' }}</el-button>
                <el-button type="default" size="small" @click="resetForm('ruleForm')">重置</el-button>
            </el-form-item>
        </el-form>

        <!-- 内弹框 -->
        <el-dialog width="30%" :title="innerTitle" :visible.sync="innerVisible" append-to-body>

            <add-service v-if='innerTitle === "选择服务项"'  @getServes='nodes => this.getChildData = nodes'/>

            <add-user v-if='innerTitle === "选择联系人"'  @getServes='nodes => this.getChildData = nodes'/>

            <add-document v-if='innerTitle === "在线文档"'  @getServes='nodes => this.getChildData = nodes'/>

            <div slot="footer" class="dialog-footer">
                <el-button @click="innerVisible = false">取 消</el-button>
                <el-button type="primary" @click="getData">确 定</el-button>
            </div>

        </el-dialog>
    </div>
</template>

<script>
import { bargainRules } from '../serve.rules'

import services from '../serve.services'

import AddService from '../../../components/AddService/index'
import AddUser from '../../../components/AddUser/index'
import addDocument from '../../../components/addDocument/index'

const rules = bargainRules()

export default {

    components: { AddService, AddUser, addDocument },

    props:{
        type:{
            type:String,
            default:"add"
        },
        serialNumber: String,
        callback: Function
    },

    data() {
        return {
            ruleForm: {
                title: '',
                paymentCycle: '',
                warrantyStartTime: '',
                cost: '',
                warrantyEndTime: '',
                costType: '339',
                status: '117',
                supplier: '',
                contactType: '345',
                description: '',
                toDepartment: [],
                toUser: [],
                toService: [],
                toDocument: []
            },
            rules,
            loading: true,
            innerVisible: false,
            innerTitle: '',
            getChildData: [],
            companyData: [],
            parentNumber: [],
            isSubmit:false
        }
    },

    created() {
        if(this.type == 'edit'){
            this.$modal.title = "修改服务";
            this.detail()
        }else if (this.type === 'add') {
            this.loading = false
        }
    },

    computed: {
        // 字典
        dictionary(){
            return this.$store.state.dictionary
        },

        // 成本单位
        costType () {
            return this.dictionary.cost_type
        },

        // 合同状态
        contractStatus() {
            return this.dictionary.contract_status
        },

        // 合同类型
        contactType() {
            return this.dictionary.contact_type
        }
    },

    mounted() {

        services.companyList()
            .then(res => this.companyData = res.list)
            .catch(err => this.$message.error(err.message))

        services.treeChildren({ type: 'group', departmentId: '99999' })
            .then(res => this.parentNumber = res.list)
            .catch(err => this.$message.error(err.message))

    },

    methods: {
        //开始时间和完成时间的对比校验
        CompareDate(d1,d2) {
            //将所有的短横线替换为斜杠
            return ((new Date(d1.replace(/-/g,"\/"))) > (new Date(d2.replace(/-/g,"\/"))));
        },
        // 请求详情
        detail() {
            services.contractDescribe({ serialNumber: this.serialNumber })
                .then( res => this.ruleForm = { ...this.ruleForm , ...res })
                .catch( err => this.$message.error(err.message))
                .finally( () => this.loading = false)
        },

        // 确认提交按钮
        submitForm(formName) {
            this.isSubmit=true
            let d1=this.ruleForm.warrantyStartTime?this.ruleForm.warrantyStartTime:''
            let d2=this.ruleForm.warrantyEndTime?this.ruleForm.warrantyEndTime:''
            let timeCompare=this.CompareDate(d1,d2)
            this.$refs[formName].validate((valid) => {
                if (valid) {
                    if (!timeCompare){
                        if(this.type === 'add') {
                            this.request({ request: services.contractAdd, params: this.setParams()})
                        } else if (this.type === 'edit') {
                            this.request({ request: services.contractEdit, params: this.setParams()})
                        }else {
                            this.$message.info('没有发送请求')
                        }
                    } else{
                        this.isSubmit=false
                        this.$message.error('结束时间应比开始时间晚，请重新选择')
                    }

                } else {
                    this.isSubmit=false
                    this.$message.error('✳为必填项，请全部填写')
                }
            });
        },

        // 设置请求数据
        setParams() {
            return {
                ...this.ruleForm,
                serialNumber: this.serialNumber && this.serialNumber,
                toDocument: this.ruleForm.toDocument.map(item => item.serialNumber),
                toService: this.ruleForm.toService.map(item => item.serialNumber),
                toUser: this.ruleForm.toUser.map(item => item.internalUserid),
                toDepartment: Array.from(new Set(this.ruleForm.toDepartment.join().split(',')))
            }
        },

        // 重置
        resetForm(formName) {
            this.$refs[formName].resetFields()
        },

        // 发起请求
        request({ request, params }) {
            const loading = this.$loading({
                lock: true,
                text: 'Loading',
                spinner: 'el-icon-loading',
                background: 'rgba(0, 0, 0, 0.7)'
            })
            request(params)
                .then( res => this.$message.success(`${this.type ==='edit' ? '编辑': '创建'}成功`))
                .catch(err =>{
                        this.isSubmit=false
                        this.$message.error(err.message)
                }
                ).finally(() => {
                    loading.close()
                    this.$modal.close()
                    this.callback()
                })
        },

        // 获取接口数据
        getData() {
            switch (this.innerTitle) {
                case '选择服务项':
                    this.ruleForm.toService = this.getChildData
                    break;
                case '选择联系人':
                    this.ruleForm.toUser = this.getChildData
                    break;
                case '在线文档':
                    this.ruleForm.toDocument = this.getChildData
                    break;
            }
            this.innerVisible = false
        },

        // 移除数据
        deleteRow(index, rows) {
            rows.splice(index, 1)
        },

        // 显示弹框
        ShowBounced(title) {
            this.innerVisible = true
            this.innerTitle = title
        }
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
    .autobox {
        /deep/ .el-col {
            height: auto;
        }
    }
</style>

